import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { suburbs } from '../../data/suburbs';
import SuburbChecker from './SuburbChecker';

export default function LocationsSection({ onQuoteClick }) {
  return (
    <section id="areas" className="dark-green-bg py-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <p className="section-label mb-4 text-[#D98A00]">Locations</p>
          <h2 className="text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold leading-[1.05] mb-6 text-white">
            Local lawn &amp; garden care for homes across Ballarat, plus commercial grounds care across Victoria.
          </h2>
          <p className="text-white/80 text-lg leading-relaxed max-w-md mb-6">
            Choose your suburb below to see local information and get a free quote from a nearby crew.
          </p>
          <div className="max-w-md mb-6">
            <SuburbChecker variant="dark" onQuoteClick={onQuoteClick} />
          </div>
          <button onClick={onQuoteClick} className="btn-gold px-6 py-3 rounded-md">
            Request Free Quote
          </button>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {suburbs.slice(0, 12).map((s) => (
            <Link
              key={s.slug}
              to={`/service-areas/${s.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="flex items-center justify-between px-5 py-4 rounded-lg border-2 border-white/30 bg-white/[0.10] hover:bg-white/[0.18] hover:border-[#D98A00] text-left transition-all group"
            >
              <span className="text-white font-bold text-base">{s.name}</span>
              <MapPin className="w-4 h-4 text-[#D98A00] opacity-90 group-hover:opacity-100" />
            </Link>
          ))}
          <Link
            to="/service-areas"
            onClick={() => window.scrollTo(0, 0)}
            data-testid="view-all-service-areas-link"
            className="sm:col-span-2 flex items-center justify-center px-5 py-4 rounded-lg bg-[#D98A00] hover:bg-[#B86F00] text-[#0A2E18] font-extrabold shadow-md transition-all"
          >
            View all {suburbs.length} service areas →
          </Link>
        </div>
      </div>
    </section>
  );
}
